import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/personal_/projects/$projectId/')({
	loader: ({ params }) => {
		throw redirect({
			to: '/personal/projects/$projectId/events',
			params: { projectId: params.projectId },
		});
	},
	component: () => null,
});
